import React from 'react';
import {Button, Stack} from '@mui/material';

import {AlertModal} from 'presentation/components';
import {translations} from 'presentation/translations-new';

import {PaymentErrorModalProps} from './types';

const {paymentErrorModal} = translations['pt-br'].privateFlow.myFinancial.openBills;

export function PaymentErrorModal({open, onClose}: PaymentErrorModalProps) {
	return (
		<AlertModal
			open={open}
			onClose={onClose}
			variant="info"
			showIcon
			customMaxWidth={420}
			headerTitle={paymentErrorModal.headerTitle}
			title={paymentErrorModal.title}
			description={paymentErrorModal.description}
			footerContent={
				<Stack width="100%">
					<Button size="large" variant="contained" fullWidth onClick={onClose}>
						{paymentErrorModal.confirm}
					</Button>
				</Stack>
			}
		/>
	);
}
